/*
 * File: c:\Users\j.mazat\Desktop\Autobuy\AutobuyBackOffice\src\Content\Contact\CompanyForm\CompanyForm.tsx
 * Project: c:\Users\j.mazat\Desktop\Autobuy\AutobuyBackOffice
 * Created Date: Monday July 17th 2023
 * Author: Jonathan Mazat
 * -----
 * Last Modified: Friday, 15th September 2023 01:12:19
 * Modified By: Simon (s.gourlet@autobuy.fr>)
 * -----
 * Copyright (c) 2023 Autobuy SAS
 * -----
 */

import { forwardRef, useImperativeHandle, useRef, useState } from "react";
import Styles from "Content/Contact/CompanyForm/CompanyForm.module.css";
import { Form, Col } from "react-bootstrap";
import AddressContact from "Content/Contact/AddressContact/AddressContact";
import translator from "MultiLanguage/TranslationWrapper";
import { Address, ContactAddress } from "../AddressContact/AddressInterface";
import PhoneInput from "react-phone-number-input";
import "react-phone-number-input/style.css";
import "Content/Contact/UserForm/PhoneInput.css";
import { TextField } from "@mui/material";

type CompanyFormProps = {
    onUpdate: Function
};

const CompanyForm = forwardRef((props: CompanyFormProps, ref) => {
    const [name, setName] = useState("");
    const [siren, setSiren] = useState("");
    // const [kbis, setKBIS] = useState<File>();
    const [phone, setPhone] = useState<string | undefined>();
    const addressRef = useRef<ContactAddress>();

    // const setKbisFile = (e: any) => {
    //     if (e.target && e.target.files && e.target.files.length > 0)
    //         return e.target.files[0];
    //     return undefined;
    // }

    useImperativeHandle(ref, () => {
        props.onUpdate();
        return {
            Name: name,
            Siren: siren,
            // KBIS: kbis,
            Phone: phone,
            address: {
                address: addressRef.current?.address,
                city: addressRef.current?.city,
                postalCode: addressRef.current?.postalCode,
                state: addressRef.current?.state,
                country: addressRef.current?.country
            }
        }
    // }, [name, kbis, phone, addressRef.current]);
    }, [name, siren, phone, addressRef.current]);

    return (
        <div className={`${Styles.formHolder}`}>
            <h3>{translator.decode("dynamic.company")}</h3>
            {/* <Form.Group className={`${Styles.formfield}`} >
                <Form.Label>
                    {translator.decode("dynamic.companyName")}
                </Form.Label>
                <Col>
                    <Form.Control type="text" value={name} onChange={(e) => {setName(e.target.value)}}/>
                </Col>
            </Form.Group> */}
            <Form.Group className={`${Styles.formfield}`} >
                <TextField required value={name ?? ""} sx={{width:"100%"}} label={translator.decode("dynamic.companyName")} size="small" onChange={(e) => {setName(e.target.value)}}/>
            </Form.Group>
            <Form.Group className={`${Styles.formfield}`} >
                <TextField required value={siren ?? ""} sx={{width:"100%"}} label={translator.decode("dynamic.siren")} size="small" onChange={(e) => {setSiren(e.target.value)}}/>
            </Form.Group>
            {/* <Form.Group className={`${Styles.formfield}`} >
                <Form.Label>
                {translator.decode("dynamic.kbis")}
                </Form.Label>
                <Col>
                <Form.Control type="file" onChange={(e) => {setKBIS(setKbisFile(e))}} accept=".pdf"/>
                </Col>
            </Form.Group> */}
            <Form.Group className={`${Styles.formfield}`} >
                <Form.Label className={`${Styles.fieldLabel}`}>
                    {translator.decode("dynamic.standard")}
                </Form.Label>
                <Col>
                    <PhoneInput autoComplete="on" value={phone} onChange={setPhone} defaultCountry="FR" />
                    {/* <Form.Control type="tel" required pattern="(\+[0-9]{2,3}|00[0-9]{1,2}|[0-9]{2})[\.\- ]?[0-9]{2}[\.\- ]?[0-9]{2}[\.\- ]?[0-9]{2}[\.\- ]?[0-9]{2}" value={phone} onChange={(e) => {setPhone(e.target.value)}}/> */}
                </Col>
            </Form.Group>
            {/* <Form.Group className={`${Styles.formfield}`} >
                <Form.Label>
                    {translator.decode("dynamic.address")}
                </Form.Label>
                <Col>
                    <AddressContact address={{
                                houseNumber: "",
                                street: "",
                                postalCode: "",
                                city: "",
                                score: 0,
                                state: "",
                            }} ref={addressRef} onUpdate={props.onUpdate}
                            />
                </Col>
            </Form.Group> */}
        </div>
    )
});

export default CompanyForm;
